<template>
	<div class="housing_options_box_detail" id="housing_options_detail">
		<TravelLineSearchFormComponent style="height: 0px; opacity: 0;"></TravelLineSearchFormComponent>
		<div v-if="$store.getters.screenWidth > 575" class="desktop_housing_options">
			<!--suite-->
			<div v-if="housing_item_active.type.name === 'suite'" class="suite_item_box">
				<div class="suite_item_box_content_box">
					<div class="suite_item_box_content">
						<div class="suite_item_box_main_description">
							<div class="suite_item_box_main_title">
								НОМЕРА
							</div>
							<div class="suite_item_box_text">
								Dolphin Planet hotel & SPA предлагает гостям номера различного уровня
								— от стандарта до премиум класса. Каждый номер выполнен в индивидуальном дизайне
								и оборудован всем необходимым для комфортного проживания. Помимо номеров,
								для всех гостей доступны общественные зоны отдыха с панорамным видом на океанариум
								и дельфинов.
							</div>
							<div class="suite_item_box_description_box">
								<div ref="info_box" style="
									display: flex;
									position: relative;
									flex-direction: column;
									flex-wrap: nowrap;
									align-content: center;
									justify-content: center;
									align-items: stretch;
								">
									<div class="suite_item_box_description_padding_box_shadow_animation">
										<div class="suite_item_box_title">
											{{housing_item_active.title}}
											<div style="display: flex;">
												<b-button class="suite_item_box_control" @click="suite_control_prev">
													<img src="../assets/img/housing_options/svg/Chevron11.svg" alt=""/>
												</b-button>
												<b-button style="margin-left: 0.5em;" class="suite_item_box_control" @click="suite_control_next">
													<img src="../assets/img/housing_options/svg/Chevron22.svg" alt=""/>
												</b-button>
											</div>
										</div>
										<div class="suite_item_box_subtitle">
											{{housing_item_active.subtitle}} &nbsp;&nbsp;&nbsp;
										</div>
										<div class="suite_item_box_description">
											{{housing_item_active.description}}
										</div>
										<div class="suite_item_box_description_info">
											<div class="suite_item_box_description_info_area">
												<div>
													{{housing_item_active.area}}
												</div>
												<div style="display: flex;
													flex-direction: row;
													flex-wrap: nowrap;
													align-content: center;
													justify-content: center;
													align-items: center;"
												>
													<span style="font-size: 0.8em;">м<sup style="font-size: 0.5em;">2</sup></span>
												</div>

											</div>
											<div class="suite_item_box_description_info_tags">
												<div :key="idx" v-for="(tag, idx) in housing_item_active.tags" class="housing_item_box_suite_description_info_tag">
													{{tag}}
												</div>
											</div>
										</div>
									</div>
									<Transition name="fade-text">
										<div :key="`housing_item_suite_${housing_item_active.id}`"
											class="housing_item_box_suite_description_padding_box"
										>
											<div class="suite_item_box_title">
												{{housing_item_active.title}}
												<div style="display: flex;">
													<b-button class="suite_item_box_control" @click="suite_control_prev">
														<img src="../assets/img/housing_options/svg/Chevron11.svg" alt=""/>
													</b-button>
													<b-button style="margin-left: 0.5em;" class="suite_item_box_control" @click="suite_control_next">
														<img src="../assets/img/housing_options/svg/Chevron22.svg" alt=""/>
													</b-button>
												</div>
											</div>
											<div class="suite_item_box_subtitle">
												{{housing_item_active.subtitle}} &nbsp;&nbsp;&nbsp;
											</div>
											<div class="suite_item_box_description">
												{{housing_item_active.description}}
											</div>
											<div class="suite_item_box_description_info">
												<div class="suite_item_box_description_info_area">
													<div>
														{{housing_item_active.area}}
													</div>
													<div style="display: flex;
														flex-direction: row;
														flex-wrap: nowrap;
														align-content: center;
														justify-content: center;
														align-items: center;"
													>
														<span style="font-size: 0.8em;">м<sup style="font-size: 0.5em;">2</sup></span>
													</div>

												</div>
												<div class="suite_item_box_description_info_tags">
													<div :key="idx" v-for="(tag, idx) in housing_item_active.tags" class="housing_item_box_suite_description_info_tag">
														{{tag}}
													</div>
												</div>
											</div>
										</div>
									</Transition>

									<div class="housing_item_box_suite_order_btn">
										<a href="#" data-tl-booking-open="true" :data-tl-room="housing_item_active.data_tl_room">ЗАБРОНИРОВАТЬ</a>
									</div>
								</div>
							</div>
						</div>
						<div class="housing_item_box_gallery_box" :class="{'full_screen': full_screen_mode === true}">
							<div class="housing_item_box_gallery">
								<img ref="gallery_img_active" @click="full_screen_mode = true"
									class="housing_item_box_gallery_img"
									:key="`item_img_active_${item_img_active.id}`"
									:src="item_img_active.src" alt=""
									@onload="$refs.gallery_img_active.classList.add('fadeIn')"
								/>
								<div class="housing_item_box_gallery_control">
									<b-button @click="gallery_control_prev" style="border-right: 0.5px solid black !important;"
										class="housing_item_box_gallery_control_button"
									>
										<img src="../assets/img/housing_options/svg/Chevron1.svg" alt=""/>
									</b-button>
									<b-button @click="gallery_control_next" style="border-left: 0.5px solid black !important;"
										class="housing_item_box_gallery_control_button"
									>
										<img src="../assets/img/housing_options/svg/Chevron2.svg" alt=""/>
									</b-button>
								</div>
								<div class="gallery_close_btn"
									@click="full_screen_mode = false">
									&times;
								</div>
							</div>
							<div style="position: absolute; color: white;">
							</div>
						</div>
						<div class="housing_item_box_menu">
							<ul >
								<li :key="`menu_${idx}`"
									v-for="(item, idx) in housing_items_suite"
									class="housing_item_box_menu_item"
									@click="handle_menu_click(item)"
								>
									<div class="housing_item_box_menu_col_title">
										{{ item.title }}
									</div>
									<div class="housing_item_box_menu_col_subtitle">
										{{ item.subtitle }}
									</div>
									<div class="housing_item_box_menu_item_border" :class="{'active': item.active}"></div>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="housing_item_box_menu_vertical_row">
					<div  style="text-align: center; position:relative;">
						<b-button class="housing_item_box_close_btn" @click="$router.push({path: '/#housing_options'})">
	<!--					<b-button class="housing_item_box_close_btn" @click="closeMenu">-->
							&times;
						</b-button>
					</div>
					<div class="housing_item_box_menu_vertical_content_box">
						<div style="border: 0.5px solid #A6CBD3; height: 100%; margin: 1em;"></div>
						<div class="housing_item_box_menu_vertical_content_button_box">
							<b-button style="border-radius: 10px 0px 0px 10px" @click="is_standard_suite_type = !is_standard_suite_type"
								class="housing_item_box_menu_vertical_content_button" :class="{'active' : is_standard_suite_type}"
							>СТАНДАРТ</b-button>
							<b-button style="border-radius: 0px 10px 10px 0px" @click="is_standard_suite_type = !is_standard_suite_type"
								class="housing_item_box_menu_vertical_content_button" :class="{'active' : !is_standard_suite_type}"
							>WELNESS</b-button>
						</div>
						<div style="border: 0.5px solid #A6CBD3; height: 100%; margin: 1em;"></div>
						<hr>
					</div>
				</div>
			</div>
			<!--chalet-->
			<div v-else-if="housing_item_active.type.name === 'chalet'" class="chalet_item_box">
				<div class="chalet_item_box_content_box">
					<div class="chalet_item_box_content">
						<div class="chalet_item_box_description">
							<div class="chalet_item_box_main_title">
								{{housing_item_active.title}}
							</div>
							<div class="chalet_item_box_scrolled">
								<img class="chalet_item_box_img" :src="housing_item_active.type.img" alt="">
								<div class="chalet_item_box_text" v-html="housing_item_active.description"></div>
								<div class="chalet_item_box_additional_info">
									<div class="chalet_item_box_description_info_area">
										<div>
											{{housing_item_active.area}}
										</div>
										<div style="display: flex;
												flex-direction: row;
												flex-wrap: nowrap;
												align-content: center;
												justify-content: center;
												align-items: center;">
											<span style="font-size: 0.8em;">м<sup style="font-size: 0.5em;">2</sup></span>
										</div>
									</div>
									<div class="chalet_item_box_description_info_tags">
										<div :key="idx" v-for="(tag, idx) in housing_item_active.tags" class="chalet_item_box_description_info_tag">
											{{tag}}
										</div>
									</div>
								</div>
							</div>
							<div class="capsule_item_box_suite_order_btn">
								<a :key="housing_item_active.data_tl_room" href="#" data-tl-booking-open="true" :data-tl-room="housing_item_active.data_tl_room">ЗАБРОНИРОВАТЬ</a>
							</div>
							<div style="z-index: 10;
								left: 0;
								right: 0;
								bottom: 0;
								width: 100%;
								height: 3em;
								margin-bottom: 58px;
								position: absolute;
								background: linear-gradient(0deg, #212121 3.59%, rgba(33, 33, 33, 0.8) 45.77%, rgba(33, 33, 33, 0) 100%);">
							</div>
						</div>
						<div class="chalet_item_box_gallery_box" :class="{'full_screen': full_screen_mode === true}">
							<div class="chalet_item_box_gallery" >
								<img ref="chalet_gallery_img_active" @click="full_screen_mode = true"
									class="chalet_item_box_gallery_img"
									:key="`chalet_item_img_active_${item_img_active.id}`"
									:src="item_img_active.src" alt=""
									@onload="$refs.chalet_gallery_img_active.classList.add('fadeIn')"
								/>
								<div class="chalet_item_box_gallery_control">
									<b-button @click="gallery_control_prev" style="border-left: 1px solid black !important; border-right: 0.5px solid black !important;"
										class="chalet_item_box_gallery_control_button"
									>
										<img src="../assets/img/housing_options/svg/Chevron1.svg" alt=""/>
									</b-button>
									<b-button @click="gallery_control_next" style="border-left: 0.5px solid black !important;"
										class="chalet_item_box_gallery_control_button"
									>
										<img src="../assets/img/housing_options/svg/Chevron2.svg" alt=""/>
									</b-button>
								</div>
								<div class="gallery_close_btn"
									@click="full_screen_mode = false">
									&times;
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="chalet_item_box_menu_vertical_row">
					<div  style="text-align: left">
						<b-button class="housing_item_box_close_btn" @click="$router.push({path: '/#housing_options'})">
							&times;
						</b-button>
					</div>
				</div>
			</div>
			<!--capsule-->
			<div v-else-if="housing_item_active.type.name === 'capsule'" class="capsule_item_box">
				<div class="capsule_item_box_content_box">
					<div class="capsule_item_box_content">
						<div class="capsule_item_box_description">
							<div class="capsule_item_box_main_title">
								{{housing_item_active.title}}
							</div>
							<div class="capsule_item_box_main_subtitle">
								{{housing_item_active.subtitle}}
							</div>
							<div class="capsule_item_box_scrolled">
								<img class="capsule_item_box_img" :src="housing_item_active.type.img" alt="">
								<div class="capsule_item_box_text" v-html="housing_item_active.description"></div>
								<div class="capsule_item_box_additional_info">
									<div class="capsule_item_box_description_info_area">
										<div>
											{{housing_item_active.area}}
										</div>
										<div style="display: flex;
												flex-direction: row;
												flex-wrap: nowrap;
												align-content: center;
												justify-content: center;
												align-items: center;">
											<span style="font-size: 0.8em;">м<sup style="font-size: 0.5em;">2</sup></span>
										</div>
									</div>
									<div class="capsule_item_box_description_info_tags">
										<div :key="idx" v-for="(tag, idx) in housing_item_active.tags" class="capsule_item_box_description_info_tag">
											{{tag}}
										</div>
									</div>
								</div>
							</div>
<!--							<b-button @click="handle_order_click" class="capsule_item_box_suite_order_btn">-->
<!--								ЗАБРОНИРОВАТЬ-->
<!--							</b-button>-->
							<div class="capsule_item_box_suite_order_btn">
								<a :key="housing_item_active.data_tl_room" href="#" data-tl-booking-open="true" :data-tl-room="housing_item_active.data_tl_room">Забронировать</a>
							</div>
							<div style="z-index: 10;
								left: 0;
								right: 0;
								bottom: 0;
								width: 100%;
								height: 3em;
								margin-bottom: 58px;
								position: absolute;
								background: linear-gradient(0deg, #212121 3.59%, rgba(33, 33, 33, 0.8) 45.77%, rgba(33, 33, 33, 0) 100%);">
							</div>
						</div>
						<div class="capsule_item_box_gallery_box" :class="{'full_screen': full_screen_mode === true}">
							<div v-if="!full_screen_mode" class="capsule_item_box_text" v-html="housing_item_active.text"></div>
							<div class="capsule_item_box_gallery">
								<img ref="capsule_gallery_img_active"  @click="full_screen_mode = true"
									class="capsule_item_box_gallery_img"
									:key="`capsule_item_img_active_${item_img_active.id}`"
									:src="item_img_active.src" alt=""
									@onload="$refs.capsule_gallery_img_active.classList.add('fadeIn')"
								/>
							</div>
							<div class="capsule_item_box_gallery_control">
								<b-button @click="gallery_control_prev" style="border-left: 1px solid black !important; border-right: 0.5px solid black !important;"
									class="capsule_item_box_gallery_control_button"
								>
									<img src="../assets/img/housing_options/svg/Chevron1.svg" alt=""/>
								</b-button>
								<b-button @click="gallery_control_next(item_img_active)" style="border-left: 0.5px solid black !important;"
									class="capsule_item_box_gallery_control_button"
								>
									<img src="../assets/img/housing_options/svg/Chevron2.svg" alt=""/>
								</b-button>
							</div>
							<div class="gallery_close_btn"
								@click="full_screen_mode = false">
								&times;
							</div>
						</div>
					</div>
				</div>
				<div class="capsule_item_box_menu_vertical_row">
					<div  style="text-align: left">
						<b-button class="housing_item_box_close_btn" @click="$router.push({path: '/#housing_options'})">
							&times;
						</b-button>
					</div>
				</div>
			</div>
		</div>
		<div v-else class="mobile_housing_options">
			<div v-if="housing_item_active.type.id === 1">
				<div class="mobile_housing_options_title">
					<router-link class="back_to_home" to="/">
						&times;
					</router-link>
					НОМЕРА
				</div>
				<div class="mobile_housing_options_title_fixed">
					<router-link class="back_to_home" to="/">
						&times;
					</router-link>
					НОМЕРА
				</div>
				<div class="" style="
					display: flex;
					position: relative;
					flex-direction: row;
					flex-wrap: nowrap;
					align-content: center;
					justify-content: center;
					align-items: center;
					padding: 0;
					margin: 0;
				">
					<div style="border: 1px solid #A6CBD3; width: 100%; margin: auto; height: 1px; position:absolute; top:0; bottom: 0; left: 0; right: 0"></div>
					<div class="mobile_housing_item_box_menu_content_button_box">
						<b-button style="border-radius: 10px 0px 0px 10px" @click="is_standard_suite_type = !is_standard_suite_type"
							class="mobile_housing_item_box_menu_content_button" :class="{'active' : is_standard_suite_type}"
						>СТАНДАРТ</b-button>
						<b-button style="border-radius: 0px 10px 10px 0px" @click="is_standard_suite_type = !is_standard_suite_type"
							class="mobile_housing_item_box_menu_content_button" :class="{'active' : !is_standard_suite_type}"
						>WELNESS</b-button>
					</div>
				</div>

				<div class="mobile_housing_options_description">
					Dolphin Planet hotel & SPA предлагает гостям номера различного уровня
					— от стандарта до премиум класса. Каждый номер выполнен в индивидуальном дизайне
					и оборудован всем необходимым для комфортного проживания. Помимо номеров,
					для всех гостей доступны общественные зоны отдыха с панорамным видом на океанариум и дельфинов.
				</div>
				<div class="mobile_housing_options_suite_items_box">
					<div class="mobile_housing_options_suite_item" v-for="housing_item in housing_items" :key="`suite_item_${housing_item.id}`">
						<div class="mobile_housing_options_suite_item_title">
							{{ housing_item.title }}
							<div class="mobile_housing_options_subtitle">{{ housing_item.subtitle }}</div>
						</div>
						<div class="mobile_housing_options_suite_item_gallery_box">
							<carousel :per-page="1" style="height: 100%; width: 100%"
								:mouse-drag="true"
								:navigationEnabled="false"
								:paginationEnabled="false"
								:navigationNextLabel="`<svg width='21' height='40' viewBox='0 0 21 40' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 40C1 31.2193 8.7463 23.6256 20 20C8.7463 16.3744 1 8.7807 1 -2.22278e-06' stroke='#A6CBD3' style='stroke:#A6CBD3;stroke-opacity:1;' stroke-width='2' stroke-linejoin='bevel'/></svg>`"
								:navigationPrevLabel="`<svg width='21' height='40' viewBox='0 0 21 40' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M20 40C20 31.2193 12.2537 23.6256 0.999999 20C12.2537 16.3744 20 8.7807 20 -2.22278e-06' stroke='#A6CBD3' style='stroke:#A6CBD3;stroke-opacity:1;' stroke-width='2' stroke-linejoin='bevel'/></svg>`"
							>
								<slide :key="`img_${idx}`" v-for="(img, idx) in housing_item.imgs">
<!--									<div class="mobile_housing_options_suite_item_gallery_img_box">-->
									<img class="mobile_housing_options_suite_item_gallery_img" :src="img.src" alt="">
<!--									</div>-->
								</slide>
							</carousel>
						</div>
						<div class="mobile_housing_options_suite_item_description" v-html="housing_item.description"></div>
						<div class="mobile_housing_options_suite_item_area">
							<div>
								{{ housing_item.area }}
							</div>
							<div style="display: flex;
								flex-direction: row;
								flex-wrap: nowrap;
								align-content: center;
								justify-content: center;
								align-items: center;"
							>
								<span style="font-size: 0.8em;">м<sup style="font-size: 0.5em;">2</sup></span>
							</div>
						</div>
						<div class="mobile_housing_options_suite_info_tags">
							<div :key="idx" v-for="(tag, idx) in housing_item_active.tags" class="mobile_housing_options_suite_info_tag">
								{{ tag }}
							</div>
						</div>
						<div class="mobile_housing_options_suite__action_button_box">
<!--							<b-button class="mobile_housing_options_suite__action_button" size="lg">ЗАБРОНИРОВАТЬ</b-button>-->
							<a class="mobile_housing_options_suite__action_button" :key="housing_item.data_tl_room" href="#" data-tl-booking-open="true" :data-tl-room="housing_item.data_tl_room">ЗАБРОНИРОВАТЬ</a>
						</div>
					</div>
				</div>
			</div>
			<div v-else>
				<div class="mobile_housing_options_title">
					<router-link class="back_to_home" to="/">
						&times;
					</router-link>
					{{housing_item_active.title}}
					<div class="mobile_housing_options_subtitle">{{housing_item_active.subtitle}}</div>
				</div>
				<div class="mobile_housing_options_title_fixed">
					<router-link class="back_to_home" to="/">
						&times;
					</router-link>
					{{housing_item_active.title}}
					<div class="mobile_housing_options_subtitle">{{housing_item_active.subtitle}}</div>
				</div>
				<div class="mobile_housing_options_img_box">
					<img class="mobile_housing_options_img" :src="housing_item_active.type.img" alt="">
				</div>
				<div class="mobile_housing_options_description">
					<div v-if="housing_item_active.type.video" class="mobile_housing_options_video_box">
						<video :src="housing_item_active.type.video"></video>
					</div>
					<div v-html="housing_item_active.description"></div>
				</div>
				<div class="mobile_housing_options_area">
					<div>
						{{housing_item_active.area}}
					</div>
					<div style="display: flex;
						flex-direction: row;
						flex-wrap: nowrap;
						align-content: center;
						justify-content: center;
						align-items: center;"
					>
						<span style="font-size: 0.8em;">м<sup style="font-size: 0.5em;">2</sup></span>
					</div>
				</div>
				<div class="mobile_housing_options_info_tags">
					<div :key="idx" v-for="(tag, idx) in housing_item_active.tags" class="mobile_housing_options_info_tag">
						{{tag}}
					</div>
				</div>
				<div class="mobile_housing_options__action_button_box">
					<a class="mobile_housing_options__action_button" :key="housing_item_active.data_tl_room" href="#" data-tl-booking-open="true" :data-tl-room="housing_item_active.data_tl_room">ЗАБРОНИРОВАТЬ</a>
<!--					<b-button class="mobile_housing_options__action_button" size="lg">ЗАБРОНИРОВАТЬ</b-button>-->
				</div>
			</div>
		</div>
	</div>
</template>
<script>

import TravelLineSearchFormComponent from '../components/TravelLineSearchFormComponent'
import {scroller} from 'vue-scrollto/src/scrollTo'


export default {
	name: "HousingOptionsComponent",
	head() {
	},

	components: {
		TravelLineSearchFormComponent,
	},
	data() {
		return {
			first_scroll_to: scroller(),
			is_standard_suite_type: true,
			full_screen_mode: false,


		}
	},
	beforeUnmount() {
		window.removeEventListener('keyup')
	},
	mounted() {
		this.first_scroll_to('#housing_options_detail')
		let self = this;
		this.$nextTick(() => {
			let new_active = this.housing_items.find(item  => item.id === parseInt(this.$route.params.id))
			if (new_active) {
				for (let item of this.housing_items) {
					item.active = false
					for (let img of item.imgs) {
						img.active = false
					}
				}
				new_active.active = true
				new_active.imgs[0].active = true
			}

			window.addEventListener('keyup', function(ev) {
				// При нажатии стрелок влево и вправо
				if (ev.key === 'ArrowRight') {
					self.gallery_control_next(ev)
				} else if (ev.key === 'ArrowLeft') {
					self.gallery_control_prev(ev)
				}else if (ev.key === ' ') {
					self.full_screen_mode = !self.full_screen_mode
				}
				if (parseInt(self.$route.params.id) !== 1 && parseInt(self.$route.params.id) !== 2) {
					try {
						if (ev.key === 'ArrowUp') {
							self.suite_control_prev(ev)
						} else if (ev.key === 'ArrowDown') {
							self.suite_control_next(ev)
						}
					} catch (e) {
						console.log('keyup err:', e)
					}
				}
			});
		})
		setTimeout(() => {

		},10)
	},
	computed: {
		housing_items_suite() {
			return this.$store.state.housing_items.filter(item => item.type.id  ===  1)
		},
		housing_items() {
			return this.$store.state.housing_items
		},
		item_img_active() {
			return this.housing_item_active.imgs.find(item => item.active  === true)
		},
		housing_item_active: {
			get() {
				let active_itm = {}
				active_itm = this.housing_items.find(item => item.active === true)
				if (active_itm && active_itm.imgs) {
					active_itm.imgs[0].active = true
				}
				return active_itm
			},
			set(val) {
				console.log('val: ', val)
			},
		},
	},
	methods: {
		handle_menu_click(item) {
			this.housing_item_active.active = false
			item.active = true

		},
		gallery_control_prev() {
			console.log('gallery_control_prev')
			let active_img_idx = this.housing_item_active.imgs.indexOf(this.item_img_active)
			let active_img_prev_idx = active_img_idx - 1
			if (active_img_prev_idx <= 0)  {
				active_img_prev_idx = this.housing_item_active.imgs.length - 1
			}
			for (let item of this.housing_item_active.imgs) {
				item.active = false
			}
			this.housing_item_active.imgs[active_img_prev_idx].active = true
		},
		gallery_control_next() {
			console.log('gallery_control_next')
			let active_img_idx = this.housing_item_active.imgs.indexOf(this.item_img_active)

			let active_img_next_idx = active_img_idx + 1
			if (active_img_next_idx === this.housing_item_active.imgs.length) {
				active_img_next_idx = 0
			}
			for (let item of this.housing_item_active.imgs) {
				item.active = false
			}
			this.housing_item_active.imgs[active_img_next_idx].active = true
		},

		suite_control_prev() {
			let active_idx = this.housing_items_suite.indexOf(this.housing_item_active)
			let active_idx_prev = active_idx - 1
			if (active_idx  ===  0) {
				active_idx_prev = this.housing_items_suite.length - 1
			}
			for (let item of this.housing_items_suite) {
				item.active = false
			}
			this.housing_items_suite[active_idx_prev].active = true
			this.housing_items_suite[active_idx_prev].imgs[0].active = true
		},
		suite_control_next()  {
			let active_idx = this.housing_items_suite.indexOf(this.housing_item_active)
			let active_idx_next = active_idx + 1
			if (active_idx === this.housing_items_suite.length - 1) {
				console.log('error this is the last suite')
				active_idx_next = 0
			}
			for (let item of this.housing_items_suite) {
				item.active = false
			}
			this.housing_items_suite[active_idx_next].active = true
			this.housing_items_suite[active_idx_next].imgs[0].active = true
		},
		handle_order_click()  {
			console.log('handle_order_click')
		},

	},

}
</script>
<style>

.fadeOut {
	animation: fadeOut 0.3s ease-out;
}

@keyframes fadeOut  {
	0%  {
		opacity: 1;
	}
	100%   {
		opacity: 0;
	}
}


.fadeIn {
	animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn  {
	0%  {
		opacity: 0;
	}
	100%   {
		opacity: 1;
	}
}

.fade-text-enter-active,
.fade-text-fade-leave-active {
	transition: opacity 0.2s ease-out;
	opacity: 1;
}

.fade-text-enter,
.fade-text-leave-to { /* .fade-leave-active below version 2.1.8 */
	opacity: 0;
}


.fade-text-enter-active,
.fade-text-leave-active {
	transition: all 0.2s ease-out;
	opacity: 1;
}

.fade-text-enter,
.fade-text-leave-to { /* .fade-leave-active below version 2.1.8 */
	opacity: 0;
}

.housing_options_box_detail {
	min-height: 100vh;
	width: 100%;

}

.suite_item_box,
.capsule_item_box,
.chalet_item_box {
	position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    background-color: #212121;
    padding: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
}

.chalet_item_box_content_box,
.capsule_item_box_content_box,
.suite_item_box_content_box {
	display: flex;
	flex-flow: row nowrap;
	width: 100%;
}
.suite_item_box_content_box {
	padding-top: 3em;
}

.chalet_item_box_content,
.capsule_item_box_content,
.suite_item_box_content {
	width: 100%;
    height: 100%;
    top: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: space-around;
    justify-content: space-between;
    align-items: flex-start;
	overflow: hidden;
}

.chalet_item_box_gallery_box,
.capsule_item_box_gallery_box,
.housing_item_box_gallery_box {
	transition: all 0.1s ease-out;
	position: relative;
	width: 40%;
	height: 100%;
	cursor: pointer;
}

.chalet_item_box_gallery_box.full_screen,
.capsule_item_box_gallery_box.full_screen,
.housing_item_box_gallery_box.full_screen {
	left: 0;right: 0;bottom: 0;top: 0;
	position: absolute;
    width: 100%;
    height: 100%;
    margin: auto;
	z-index: 1000;
	background-color: #161616;
}

.chalet_item_box_gallery_box.full_screen .chalet_item_box_gallery_img,
.capsule_item_box_gallery_box.full_screen .capsule_item_box_gallery_img,
.housing_item_box_gallery_box.full_screen .housing_item_box_gallery_img {
	width: 80%;
	height: 100%;
	display: flex;
	margin: auto;
	position: relative;
	object-fit: contain !important;

}

.gallery_close_btn {
	display: none;
	position: absolute;
    top: 0;
    right: 1em;
    font-size: 3em;
    color: #A6CBD3;
	z-index: 1000;
}
.chalet_item_box_gallery_box.full_screen .gallery_close_btn,
.capsule_item_box_gallery_box.full_screen .gallery_close_btn,
.housing_item_box_gallery_box.full_screen .gallery_close_btn {
	display: block;
}


.capsule_item_box_gallery_box {
	position: relative;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;

}
.housing_item_box_gallery_box {
	margin-left: 2em;
}

.chalet_item_box_gallery,
.capsule_item_box_gallery,
.housing_item_box_gallery {
	position: relative;
	height: 100%;
	width: 100%;
	z-index: 10;
}



.capsule_item_box_gallery_box.full_screen .capsule_item_box_gallery {
	height: 100%;
}

.capsule_item_box_gallery {
	height: auto;
	/*height: ;*/
}

.chalet_item_box_gallery_img,
.capsule_item_box_gallery_img,
.housing_item_box_gallery_img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	position: absolute;
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
}
.capsule_item_box_gallery_img {
	position: relative;
	height: auto;
    min-height: 65vh;
    object-fit: cover;
}

.chalet_item_box_gallery_control,
.capsule_item_box_gallery_control,
.housing_item_box_gallery_control {
	position: absolute;
	height: 58px;
	font-weight: 200;
	bottom: 0;
	color: black;
	font-size: 2em;
	display: flex;
	z-index: 50;

}

.housing_item_box_gallery_control {
	right: 0;
}

.chalet_item_box_gallery_control,
.capsule_item_box_gallery_control {
	left: 0;
}

.chalet_item_box_gallery_control_button:hover,
.chalet_item_box_gallery_control_button:active,
.chalet_item_box_gallery_control_button:focus,
.chalet_item_box_gallery_control_button,
.capsule_item_box_gallery_control_button:hover,
.capsule_item_box_gallery_control_button:active,
.capsule_item_box_gallery_control_button:focus,
.capsule_item_box_gallery_control_button,
.housing_item_box_gallery_control_button:hover,
.housing_item_box_gallery_control_button:active,
.housing_item_box_gallery_control_button:focus,
.housing_item_box_gallery_control_button {
	color: black;
	background-color: #A6CBD3 !important;
	border: none ;
	border-radius: 0 !important;
	box-shadow: none !important;
	padding: 0 0.5em !important;
    font-size: 1.2em !important;

	display: flex !important;
    position: relative;
    align-content: center;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
	cursor: pointer;

}

.chalet_item_box_gallery_control_button > img,
.capsule_item_box_gallery_control_button > img,
.housing_item_box_gallery_control_button > img {
	opacity: 0.6;
}

.chalet_item_box_gallery_control_button:hover > img,
.capsule_item_box_gallery_control_button:hover > img,
.housing_item_box_gallery_control_button:hover > img {
	opacity: 1;
}

.chalet_item_box_gallery_control_button:active,
.capsule_item_box_gallery_control_button:active,
.housing_item_box_gallery_control_button:active {
	background-color: #A6CBD3 !important;
}

.chalet_item_box_description,
.capsule_item_box_description,
.suite_item_box_main_description {
    color: white;
    letter-spacing: 0.05em;
    position: relative;
    height: 100%;


}

.chalet_item_box_description,
.capsule_item_box_description {
	position: relative;
	padding-top: 2em;
}

.suite_item_box_main_description {
	padding: 2.5em;
    padding-top: 0;
    padding-right: 0;
}

.chalet_item_box_description,
.capsule_item_box_description {
	padding-left: 10%;
	padding-right: 5%;
	position: relative;
}


.suite_item_box_main_description {
	width: 40%;
}
.chalet_item_box_description,
.capsule_item_box_description {
	width: 60%;
}

.chalet_item_box_main_title,
.capsule_item_box_main_title,
.capsule_item_box_main_subtitle,
.suite_item_box_main_title {
	letter-spacing: 0.15em;
	font-size: 2em;
	padding-bottom: 0.5em;
	border-bottom: 3px solid white;


}

.chalet_item_box_main_title,
.capsule_item_box_main_title {
	line-height: 1.3em;
	text-shadow: 0px 0px 15px black;
}

.capsule_item_box_main_title {
	border-bottom: none;
	padding-bottom: 0em;
}
.capsule_item_box_main_subtitle {
	font-size: 1em;
	border-bottom: 3px solid white;
	padding-bottom: 1.5em;
	letter-spacing: 0.3em;
}
.capsule_item_box_scrolled {
	overflow: auto;
	height: calc(100% - 58px - 7em);
	padding-bottom: 2em;
}

.chalet_item_box_scrolled {
	overflow: auto;
	height: calc(100% - 58px - 4.8em);
	padding-bottom: 2em;
}

.chalet_item_box_img,
.capsule_item_box_img {
	padding: 1em 0em;
	width: 100%;
	height: auto;
	object-fit: cover;
    max-height: 400px;

}

.chalet_item_box_text,
.capsule_item_box_text,
.suite_item_box_text {
	font-size: 0.7em;
	padding: 1em 0em;
	font-weight: 500;
}
.capsule_item_box_text {
	padding: 3em 0em;
}

.capsule_item_box_text p {
	margin-bottom: 0;
	color: white;
	font-weight: 200;
}

.suite_item_box_description_box {
	position: absolute;
	display: flex;
	flex-direction: column;
    left: 0;
    bottom: 0;
    width: 120%;
    /*min-height: 55%;*/
    background-color: #A6CBD3;
    z-index: 30;
	color: black;
}

.suite_item_box_description_padding_box_shadow_animation {
	position: relative;
	opacity: 0;
}


.suite_item_box_description_padding_box_shadow_animation,
.housing_item_box_suite_description_padding_box {
	min-height: 50vh;
	top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 1.5em;
    padding-bottom: 0;
}
.housing_item_box_suite_description_padding_box {
	position: absolute;
}

.suite_item_box_title {
	font-size: 2em;
    padding-top: 0.2em;
    font-weight: 300;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: space-between;
    align-items: center;
}

.suite_item_box_control,
.suite_item_box_control:active,
.suite_item_box_control:hover,
.suite_item_box_control:focus {
	box-shadow: none !important;
	border-radius: 1000px !important;
	border: 2px solid black !important;
	background-color: transparent !important;
	padding: 0px !important;
	display: flex !important;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	width: 2em;
	height: 2em;
	opacity: 0.5;

}
.suite_item_box_control:hover {
	opacity: 0.8;
}
.suite_item_box_control:active {
	background-color: #A6CBD3 !important;
}

.suite_item_box_control img {
	width: 70%;
	height: 70%;
	display: flex;
}
.suite_item_box_subtitle {
	font-size: 1em;
    padding-bottom: 0.7em;
    font-weight: 500;
}
.suite_item_box_description {
    font-size: 0.8em;

}

.chalet_item_box_additional_info,
.capsule_item_box_additional_info,
.suite_item_box_description_info {
	padding-top: 1em;
	display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: space-between;
    align-items: center;
}

.capsule_item_box_additional_info,
.chalet_item_box_additional_info {
	color: #A6CBD3;
}
.suite_item_box_description_info {
	color: black;
}

.chalet_item_box_suite_order_btn,
.capsule_item_box_suite_order_btn {
	position: absolute;
    bottom: 0;
    height: 58px;
    width: 100%;
    left: 0;
    right: 0;
	border-radius: 0 !important;
	background-color: #A6CBD3 !important;
	border: none !important;
	/*border-top: 1px solid black !important;*/
	box-shadow: none !important;
	color: black!important;
	overflow: hidden;
	display: flex;
}

.chalet_item_box_suite_order_btn a, .chalet_item_box_suite_order_btn a:hover,
.capsule_item_box_suite_order_btn a, .capsule_item_box_suite_order_btn a:hover {
	color: black !important;
    position: relative;
    text-decoration: none;
    text-transform: uppercase;
    font-size: 1.2em;
    font-width: 200;
    width: 100%;
    height: 100%;
    text-align: center;
    line-height: 58px;
	opacity: 0.7;
}

.chalet_item_box_suite_order_btn a:hover,
.capsule_item_box_suite_order_btn a:hover {
	opacity: 1;
}

.housing_item_box_suite_order_btn,
.housing_item_box_suite_order_btn:hover,
.housing_item_box_suite_order_btn:active,
.housing_item_box_suite_order_btn:focus	{
	padding: 1em !important;
	width: 100%;
	height: 100%;
	background-color: transparent !important;
	border-radius: 0 !important;
	margin: 0;
	color: black !important;
	border: none !important;
	border-top: 1px solid black !important;
	box-shadow: none !important;
	z-index: 5;
	display: flex;
	cursor: pointer;
}

.housing_item_box_suite_order_btn a,
.housing_item_box_suite_order_btn a:hover,
.housing_item_box_suite_order_btn a:active,
.housing_item_box_suite_order_btn a:focus {
	width: 100% !important;
	height: 100% !important;
	color: black !important;
	text-decoration: none;
	text-transform: uppercase;
	text-align: center;
}

.housing_item_box_suite_order_btn:active {
	background-color: #A6CBD3 !important;
}

.chalet_item_box_description_info_area,
.capsule_item_box_description_info_area,
.suite_item_box_description_info_area {
	width: 30%;
	font-size: 2.2em;
	text-align: center;
	display: flex;
	flex-flow: row nowrap;
	align-items: center;
	justify-content: center;
	padding: 0.3em 0.5em;
}

.chalet_item_box_description_info_tags,
.capsule_item_box_description_info_tags,
.suite_item_box_description_info_tags {
	display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
}

.chalet_item_box_description_info_tag,
.capsule_item_box_description_info_tag,
.housing_item_box_suite_description_info_tag {
    padding: 0.05em 0.5em;
    margin: 0.25em;
    border-radius: 8px;
	font-size: 0.7em;

}

.chalet_item_box_description_info_tag,
.capsule_item_box_description_info_tag {
	border: 1px solid #A6CBD3;
	color: #A6CBD3;
}

.housing_item_box_suite_description_info_tag {
	border: 1px solid black;
	color: black;
}

.housing_item_box_menu {
	display: flex;
    width: 20%;
    font-size: 0.9em;
    font-weight: 200;
    /* padding: 1em; */
    max-height: 100%;
    padding-top: 0;
    padding-left: 2em;
    color: #A6CBD3;
    overflow-y: auto;
}

.housing_item_box_menu_item {
	cursor: pointer;
	opacity: 0.5;

}
.housing_item_box_menu_item:has(.active) {
	opacity: 1;
	font-weight: 700;
}

.housing_item_box_menu_item > .housing_item_box_menu_item_border.active,
.housing_item_box_menu_item:hover > .housing_item_box_menu_item_border {
	width: 100%;
	opacity: 1;
}

.housing_item_box_menu_item_border {
	transition: width 0.3s ease-in-out;
	width: 0;
	height: 2px;
	background-color: #A6CBD3;
}


.housing_item_box_menu_col_title {
	padding-top: 1em;
	font-size: 1.5em;
	letter-spacing: 0.1em;
}
.housing_item_box_menu_col_title.active {
}



.housing_item_box_menu_col_subtitle {
	font-size: 0.7em;
}

.chalet_item_box_menu_vertical_row,
.capsule_item_box_menu_vertical_row,
.housing_item_box_menu_vertical_row {
    width: 10%;
    text-align: center;
    display: flex;
    flex-flow: row nowrap;
    top: 0;
    right: 1.2em;
	padding: 0 1em;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: space-between;
    align-items: center;
	overflow: hidden;
}

.housing_item_box_close_btn,
.housing_item_box_close_btn:hover,
.housing_item_box_close_btn:active,
.housing_item_box_close_btn:focus {
	background-color: transparent !important;
	border: none !important;
	box-shadow: none !important;
	font-size: 3em !important;
	line-height: 1em !important;
	padding: 0 !important;
	cursor: pointer;

}
.housing_item_box_close_btn:hover {
	color: white !important;
}

.housing_item_box_close_btn {
	color: #A6CBD3 !important;
	cursor: pointer;
	font-weight: 700;
	font-size: 3em;
	line-height: 1em;
	padding: 0;
	text-align: center;
	background-color: transparent;
}

.housing_item_box_menu_vertical_content_box {
    display: flex;
    height: 100%;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: space-between;
    align-items: center;
}

.housing_item_box_menu_vertical_content_button_box {
	transform: rotate(90deg);
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    padding: 1em;
    background-color: #212121;
}

.housing_item_box_menu_vertical_content_button,
.housing_item_box_menu_vertical_content_button:hover,
.housing_item_box_menu_vertical_content_button:active,
.housing_item_box_menu_vertical_content_button:focus  {
	background-color: transparent !important;
	box-shadow: none !important;
	border: 1px solid #A6CBD3 !important;
	padding: 0.5em 1em !important;
	font-size: 0.8em !important;
	font-weight: 200 !important;
	letter-spacing: 0.2em !important;
	color: #A6CBD3 !important;
}

.housing_item_box_menu_vertical_content_button.active {
	background-color: #A6CBD3 !important;
	box-shadow: none !important;
	color: #212121 !important;
}

.housing_item_box_menu_vertical_content_button {
	border-radius: 0;
}

.mobile_housing_options {
	color: #A6CBD3;
	background-color: #101010;
}
.mobile_housing_options_img_box {
	width: 100%;
	height: 45vh;
}
.mobile_housing_options_img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.mobile_housing_options_title {
	position: relative;
	font-size: 2em;
	font-weight: 200;
	padding: 0.5em 1em;
	background-color: #101010;
	opacity: 0;
}

.mobile_housing_options_title_fixed {
	position: fixed;
	top: 0;
	width: 100%;
	font-size: 2em;
	font-weight: 200;
	padding: 0.5em 1em;
	background-color: #101010;
	z-index: 1000;
}

.mobile_housing_item_box_menu_content_button_box {
	z-index: 100;
	padding: 1em;
	background-color: #101010;
}

.mobile_housing_item_box_menu_content_button {
	border: 1px solid #A6CBD3 !important;
	color: #A6CBD3 !important;
	box-shadow: none !important;
}
.mobile_housing_item_box_menu_content_button.active {
	background-color: #A6CBD3 !important;
	color: #101010 !important;
}

.mobile_housing_options_subtitle {
	font-size: 0.4em;
}
.back_to_home {
	font-weight: 700;
	display: flex;
    position: absolute;
    top: 0;
    /* left: 0; */
    right: 0.25em;
    bottom: 0;
    z-index: 100;
	color: #A6CBD3;
    height: 100%;
    font-size: 2em;
    /* line-height: 0em; */
    text-decoration: none;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;

}
.back_to_home:hover,
.back_to_home:active {
	color: white;
	text-decoration: none;
}

.mobile_housing_options_description {
	padding: 1em;
	padding-top: 2em;
}

.mobile_housing_options_suite_items_box {

}
.mobile_housing_options_suite_item {
	background-color: #212121;
	border-radius: 10px;
	margin: 1em;
	margin-bottom: 3em;
}

.mobile_housing_options_suite_item_title {
	font-size: 2.5em;
	padding: 0.5em;
}
.mobile_housing_options_suite_item_description {
	padding: 2em 1em;
	color: white;
}

.mobile_housing_options_suite_item_gallery_box {
	/*height: 50vh;*/
}
.mobile_housing_options_suite_item_gallery_img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.mobile_housing_options_video_box {
	width: 100%;
	height: 100%;
}
.mobile_housing_options_video_box video {
	width: 100%;
	height: 100%;
}
.mobile_housing_options_area,
.mobile_housing_options_suite_item_area {
	display: flex;
    flex-direction: row;
    font-size: 2.5em;
    width: 100%;
    text-align: center;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    align-items: center;
}

.mobile_housing_options_info_tags,
.mobile_housing_options_suite_info_tags {
	display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
}

.mobile_housing_options_info_tag {
    padding: 0.05em 0.5em;
    margin: 0.25em;
    border-radius: 8px;
	font-size: 0.9em;
	background-color: #161616;
}
.mobile_housing_options_suite_info_tag {
    padding: 0.05em 0.5em;
    margin: 0.25em;
    border-radius: 8px;
	font-size: 0.9em;
	background-color: #161616;
}

.mobile_housing_options__action_button_box {
	display: flex;
	width: 100%;
	justify-content: center;
	align-items: center;
}
.mobile_housing_options__action_button {
	margin: 2em 1em;
	padding: 1em 2em !important;
	background-color: #9CCCD4 !important;
	border-radius: 8px;
	color: #1E1E1C !important;
	letter-spacing: 0.3em;
	width: 100%;
    text-align: center;
    text-decoration: none;
}
.mobile_housing_options__action_button:hover {
	text-decoration: none;
}

.mobile_housing_options_suite__action_button_box {
	display: flex;
	width: 100%;
	justify-content: center;
	align-items: center;
}
.mobile_housing_options_suite__action_button {
	margin: 2em 0em;
    padding: 1em 2em !important;
    margin-bottom: 0 !important;
    background-color: #9CCCD4 !important;
    border-radius: 0px 0px 8px 8px !important;
    color: #1E1E1C !important;
    letter-spacing: 0.3em;
    width: 100%;
    text-align: center;
}
.mobile_housing_options_suite__action_button:hover {
	text-decoration: none;
}


@media (max-width: 575px) {

}

@media (min-width: 1600px) {
.suite_item_box_description_box {
	font-size: 0.8em;
}
}
</style>